<script lang="ts">
    import { mealyMachine_executeSingleStep } from "../../actions/machine";
    import * as F from 'fp-ts/function';

    import { getUpdateMachineState } from '../../mealy/context';
    import type { MachineStateMealy_DoorSystem } from "../../state/machineState";
    import type { MealyExecutionState } from "../../state/executionState";
    import { EditMode } from "../../state/uiState";
    import {produce} from "immer";
    import { callIfExecuted, mealyStartAnimation, startAnimationIfExecuted } from "../../mealy/mealyExecute";
    import Door from "./Door.svelte";

    export let machineState: MachineStateMealy_DoorSystem;

    export let mealyExecutionState: MealyExecutionState;
    export let isExecuting: boolean;

    const updateMachineState = getUpdateMachineState();

    function doorOpen(machineState: MachineStateMealy_DoorSystem, doorNr: number) {
        if (machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION) {            
            if (machineState.doorSystemState.doorsOpen[doorNr] && machineState.doorSystemState.previousDoorsOpen[doorNr] === false) {
                // Tür öffnet sich
                return machineState.animation.progress;
            } else if (machineState.doorSystemState.doorsOpen[doorNr] == false && machineState.doorSystemState.previousDoorsOpen[doorNr]) {
                // Tür schließt sich
                return 1 - machineState.animation.progress;
            } else {
                if (machineState.doorSystemState.doorsOpen[doorNr]) {
                    return 1;
                } else {
                    return 0;
                }
            }
        } else if (machineState.uiState.editMode === EditMode.EXECUTION) {
            if (mealyExecutionState.lastTransitionOutput[doorNr] === 'O') {
                return 1;
            } else {
                return 0;
            };
        } else {
            return 0;
        }
    }

    $: door0Open = doorOpen(machineState, 0);
    $: door1Open = doorOpen(machineState, 1);
    $: door2Open = doorOpen(machineState, 2);

    // $: door1Open = (() => {
    //     if (machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION) {            
    //         if (machineState.doorSystemState.doorsOpen[0] && machineState.doorSystemState.previousDoorsOpen[0] === false) {
    //             // Tür öffnet sich
    //             return machineState.animation.progress;
    //         } else if (machineState.doorSystemState.doorsOpen[0] == false && machineState.doorSystemState.doorsOpen[0]) {
    //             // Tür schließt sich
    //             return 1 - machineState.animation.progress;
    //         } else {
    //             if (machineState.doorSystemState.doorsOpen[0]) {
    //                 return 1;
    //             } else {
    //                 return 0;
    //             }
    //         }
    //     } else if (machineState.uiState.editMode === EditMode.EXECUTION) {
    //         if (mealyExecutionState.lastTransitionOutput[0] === 'O') {
    //             return 1;
    //         } else {
    //             return 0;
    //         };
    //     } else {
    //         return 0;
    //     }
    // })();


    $: isOpen = (() => {
        // if ($state.uiState.editMode === EditMode.EXECUTION_SINGLE_STEP && mealyExecutionState.lastTransition) {
        if (isExecuting) {
            return [
                mealyExecutionState.lastTransitionOutput[0] === 'O',
                mealyExecutionState.lastTransitionOutput[1] === 'O',
                mealyExecutionState.lastTransitionOutput[2] === 'O',
            ]}
        else {
            return [
                false,
                false,
                false,
            ]
        }
    })()


    function doorsOpen(doorsStr: string) {
        return [
            doorsStr[0] === 'O',
            doorsStr[1] === 'O',
            doorsStr[2] === 'O'
        ];
    }

    function updateDoorSystemState(machineState: MachineStateMealy_DoorSystem) {
        // machineState.doorSystemState.
        return produce(machineState, draft => {
            draft.doorSystemState.previousDoorsOpen = draft.doorSystemState.doorsOpen;
            draft.doorSystemState.doorsOpen = doorsOpen(machineState.executionState.lastTransitionOutput);
        });
    }
    
    const updateDoorSystemStateIfExecuted = callIfExecuted(updateDoorSystemState);

    function handleButtonClick(buttonChar: string) {
        if (machineState.uiState.editMode === EditMode.EXECUTION || machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION) {
        // if(isExecuting) {
            const [newMachineState, hasBeenExecuted] = F.pipe(
                mealyMachine_executeSingleStep(machineState, buttonChar),
                startAnimationIfExecuted,
                updateDoorSystemStateIfExecuted,
            );

            updateMachineState(newMachineState);
        }
    }

    // Bei scale = 1 ist das div 380x280 groß.
    const scale = 0.8;
    const width = 380*scale;
    const height = 280*scale;
</script>

<!-- padding 10 | weiß 40 | Tür 80 | weiß 60 | Tür 80 | weiß 60 | Tür 80 | weiß 40 | Rand rechs -->
<!--              0         40       120       180      260       320      400     | 440        -->

<!-- padding 10 | weiß 30 | Tür 80 | weiß 40 | Tür 80 | weiß 40 | Tür 80 | weiß 30 | Rand rechs -->
<!--              0         30       110       150      230       270      350     | 380        -->

<!-- padding 10 | weiß 20 | Tür 80 | weiß 30 | Tür 80 | weiß 30 | Tür 80 | weiß 20 | Rand rechs -->
<!--              0         20       100       130      210       240      320     | 340        -->
<div style="width: {width}px; height: {height}px; position: relative; transform-origin: top left; transform: scale({scale})">    
    <div style="position: absolute; top: 40px; left: 30px;">
        <Door open={door0Open}></Door>
    </div>
    <button style="position: absolute; top: 200px; left: 30px;" class="doorButton" on:click={()=>handleButtonClick('1')}>1</button>

    <div style="position: absolute; top: 40px; left: 150px;">
        <Door open={door1Open}></Door>
    </div>
    <button style="position: absolute; top: 200px; left: 150px;" class="doorButton" on:click={()=>handleButtonClick('2')}>2</button>

    <div style="position: absolute; top: 40px; left: 270px;">
        <Door open={door2Open}></Door>
    </div>
    <button style="position: absolute; top: 200px; left: 270px;" class="doorButton" on:click={()=>handleButtonClick('3')}>3</button>
</div>

<style>
    .doorButton {
        width: 80px;
        height: 40px;
        border-radius: 10px;
        background-color: #74cffc;
        box-shadow: none;

        padding: 6.5px;
        border: none;
        margin: 0px;

        transition: none;
        
        font-size: 24px;
        font-weight: 600;

        /* Text vertikal zentrieren */
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .doorButton:hover {
        background-color: #67b5db;
        color: black;
    }
</style>